/** every object a dead subtree strongly implies: nodes + their materials (property
 * owners can be materials of contained meshes) — duck-typed, works on any three.js.
 * Used by capture-side registries to PRUNE entries when a delete permanently leaves
 * the undo history (the capture systems must never be the leak). */
export function collectSubtree(root: object): Set<object> {
    const dead = new Set<object>();
    const walk = (node: object) => {
        if (dead.has(node)) return;
        dead.add(node);
        const material = (node as { material?: unknown }).material;
        for (const m of Array.isArray(material) ? material : material ? [material] : []) {
            if (m && typeof m === "object") dead.add(m as object);
        }
        const children = (node as { children?: readonly unknown[] }).children;
        if (Array.isArray(children)) {
            for (const child of children) {
                if (child && typeof child === "object") walk(child as object);
            }
        }
    };
    walk(root);
    return dead;
}
